import React from 'react';
import { css } from '@emotion/react';
import {
    BodyCell,
    BodyRow,
    OpenButton,
    ProfilePlaceholder,
    ProfileValue,
    ShipperMeta,
    ShipperName,
    Skipped,
} from './blocks';
import { EMPTY_VALUE, SHIPPER_COLUMNS } from './constants';
import RowActionsMenu from '../modals/RowActionsMenu';
import RoutingToggle from './RoutingToggle';
import { profileSummaryFor } from './utils';

// One renderer per `SHIPPER_COLUMNS` key; columns without one are in SKIPPED_FIELDS.
const CELLS = {
    shipper: ({ client }) => (
        <>
            <ShipperName>{client?.business_name || EMPTY_VALUE}</ShipperName>
            <ShipperMeta>
                {client?.email || EMPTY_VALUE}
                <Skipped />
            </ShipperMeta>
        </>
    ),
    // Skipped like the others, but holds the row height the Figma draws.
    stage: () => <Skipped minHeight="25px" />,
    // Same column the shipper page's Integrations tab shows.
    orderEntry: ({ client }) => client?.dispatch_integration_type || EMPTY_VALUE,
    routing: ({ client, onRoutingChange, routingDisabled }) => (
        <RoutingToggle client={client} onChange={onRoutingChange} disabled={routingDisabled} />
    ),
    profiles: ({ assignment, assignmentUnavailable }) => {
        if (assignmentUnavailable) return EMPTY_VALUE;
        const profiles = profileSummaryFor(assignment);
        return profiles ? (
            <ProfileValue title={profiles.all}>
                {profiles.first}
                {profiles.more > 0 && ` +${profiles.more}`}
            </ProfileValue>
        ) : (
            <ProfilePlaceholder>none</ProfilePlaceholder>
        );
    },
    actions: ({ onOpen, onDetails, onSignIn }) => (
        <span
            css={css`
                align-items: center;
                display: inline-flex;
                gap: 2px;
            `}
        >
            <OpenButton onClick={onOpen}>Open</OpenButton>
            {/* Details is the only way to reach a shipper's Mileage (PC Miler) setup. */}
            <RowActionsMenu
                items={[
                    { key: 'details', label: 'Details', onClick: onDetails },
                    { key: 'signIn', label: 'Sign In', onClick: onSignIn },
                ]}
            />
        </span>
    ),
};

const ShipperRow = (props) => (
    <BodyRow>
        {SHIPPER_COLUMNS.map(({ key, align }) => {
            const Cell = CELLS[key];
            return (
                <BodyCell key={key} align={align}>
                    {Cell ? <Cell {...props} /> : <Skipped />}
                </BodyCell>
            );
        })}
    </BodyRow>
);

export default ShipperRow;
